export enum InvitationTypes {
  unknown = 0,
  respondentInvite = 1,
  respondentReminder = 2
}
